import { propOr } from 'ramda';

export const getVersionToString = (version) => `${propOr(1, 'major', version)}.${propOr(0, 'minor', version)}`;
